<template>
  <div>

    <h3 v-if="msguser && msguser != ''" style="color:green;text-shadow:0px 0px 3px #a5a5a5">
      {{ msguser }}
    </h3>
    <!-- REQUEST SENT
    <section class="booking__invitation" v-if="booking && booking.iam == 'invited'">
      <p>
        Thanks {{ booking.user.fullName }}, <strong>you have sent your request</strong> to view this {{ booking.property.features.slice(0,2).join(', ') }} on {{ booking.property.address.street+', '+booking.property.address.county }} at {{ niceDate(booking.booking.date_suggested) }}.
      </p>
      <p><b>We will confirm your viewing as soon as we can.</b></p>
      <a :href="'https://bestagent.property/p/'+booking.property.propertyId" target="_blank"><span v-if="booking.property.mainImage === '' || booking.property.mainImage === null">View Property</span><img class="booking__invitation__property-img" v-show="booking.property.mainImage !== '' || booking.property.mainImage !== null" :src="'https://d3acvr808w2me4.cloudfront.net/'+booking.property.mainImage"/></a>
      <div class="booking__confirmation__buttons">
        <button class="btn btn--bordered booking__cancel-btn" @click.prevent="processActions('cancel')">Cancel request</button>
      </div>
    </section> -->
    <div v-if="booking && booking.iam == 'inviter'" class="booking__request-sent text-center"> <!-- Agent -->
      <p>
        Waiting for {{ booking.user.fullName }} schedule suggestion to view {{ booking.property.address.street }}, £{{ niceValue(booking.property.price) }}
      </p>
      <div class="booking__request-sent__img">
        <a :href="'https://bestagent.property/p/'+booking.property.propertyId" target="_blank">
          <img class="booking__invitation__property-img" :src="fixImg(booking.property.mainImage)" v-if="booking.property.mainImage !== null" alt="property image"/>
          <span v-if="booking.property.mainImage === '' || booking.property.mainImage === null">View property</span>
        </a>
      </div>
    </div>
    <div class="margin-top-60 text-center" v-else>
      <p class="mdc-theme-primary-dark loading-text">Loading<span>.</span><span>.</span><span>.</span></p>
    </div>
  </div>
</template>
<script>
import api from '@/libs/api.js';

export default {
	props: {
		booking: Object
	},
	data: function() {
		return {msguser: undefined}
	},
	created: async function() {
    await this.processActions();
    if (this.booking.iam == 'invited' && !this.$parent.action) {
      this.processActions('suggest');
    }
  },
	methods: {
    fixImg(img) {
      if (img.indexOf('https://') !== -1) {
        return img;
      } else {
        return `https://d3acvr808w2me4.cloudfront.net/${img}`;
      }
    },
    async processActions(forceaction,forceparams) { // App actions for GET and Live inputs
      const validatePath = window.location.pathname.split('/');
      const params = forceparams ? forceparams : this.$parent.params;
      if ((!this.$parent.action && !forceaction)) {
        return false;
      }
      const hasGET = validatePath[4] ? true : false;
      const cleanPath = `/${validatePath[1]}/${validatePath[2]}/${validatePath[3]}`;
      const action = forceaction ? forceaction : this.$parent.action;
      if (action == 'cancel') {
        if (confirm('Are you sure you want to cancel this viewing?') === false) {
          return true;
        }
      }
      let bookingUpdate;
      try {
        switch(action) {
          case "confirm":
           bookingUpdate = await api({endpoint: this.config.services.booking, path: '/bookingInvitation/'+this.$parent.trackId+'/'+this.$parent.userId, method: 'POST', body: {
             action: "confirm"
           }});
           break;
          case "later":
           bookingUpdate = await api({endpoint: this.config.services.booking, path: '/bookingInvitation/'+this.$parent.trackId+'/'+this.$parent.userId, method: 'POST', body: {
             action: "later",
             interval: params
           }});
           break;
          case "suggest":
           bookingUpdate = await api({endpoint: this.config.services.booking, path: '/bookingInvitation/'+this.$parent.trackId+'/'+this.$parent.userId, method: 'POST', body: {
              action: "suggest"
           }});
           break;
          case "cancel":
           bookingUpdate = await api({endpoint: this.config.services.booking, path: '/cancel/'+this.$parent.trackId+'/'+this.$parent.userId, method: 'GET'});
           break;
          default:

           break;
        }
      } catch(e) {
        console.log(e.message);
        if (hasGET)window.location.pathname = cleanPath;
      }
      if (!bookingUpdate) { // Error
        return false;
      } else {
        if (action == 'cancel') {
          //this.msgUser('Booking view cancelled.');
          //setTimeout(function(){
            window.location.pathname = cleanPath;
          //},2000);
        } else if (action == 'suggest') {
          if (hasGET) {
            window.location.pathname = cleanPath;
          } else {
            this.$parent.booking.booking.phase = 'schedule';
            this.$parent.phase = 'schedule';
            this.$parent.booking.booking.status = 'pending';
            window.location.pathname = window.location.pathname.replace('suggest', 'newsuggest');
          }
        } else if (action == 'confirm') {
          if (hasGET) {
            window.location.pathname = cleanPath;
          } else {
            this.$parent.booking.booking.phase = 'schedule';
            this.$parent.booking.booking.status = 'confirm';
            this.$parent.phase = 'schedule';
            this.$parent.booking.booking.nextaction = this.$parent.booking.iam == 'inviter' ? 'invited' : 'inviter';
          }
        } else if (action == 'later') {
          this.$parent.booking.booking.date_remember = (new Date().getTime() + (parseInt(params) * (60*1000)));
          this.booking.booking.date_remember = (new Date().getTime() + (parseInt(params) * (60*1000)));
          this.msgUser('You will be reminded, '+niceDate(this.$parent.booking.booking.date_remember));
        }
      }

    },
    msgUser(msg) {
      this.msguser = msg;
    },
    niceValue(value) {
      let kk = '';
      if (value.toString().length > 3) {
        kk = 'k';
      } else if (value.toString().length > 6) {
        kk = 'kk';
      }
      return value.toString().substr(0,3)+kk;
    },
    niceDate(datetime,nohours,withminutes) {
      var notnow = new Date(datetime);
      var now = new Date();
      var days = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
      var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];

      var day = days[ notnow.getDay() ];
      var month = months[ notnow.getMonth() ];

      var date = notnow.getDate();
      var hours = notnow.getHours();
      var ampm = hours >= 12 ? ' pm' : ' am';
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      var dateString = '';
      if (notnow.getDay() == now.getDay() && notnow.getMonth() == notnow.getMonth() && notnow.getFullYear() == notnow.getFullYear()) {
        dateString += "Today";
      }
      else if (notnow.getDay() == (now.getDay()+1) && notnow.getMonth() == notnow.getMonth() && notnow.getFullYear() == notnow.getFullYear()) {
        dateString += "Tomorrow";
      } else {
        dateString += day+" " +date;
        // dateString += (now.getMonth() == notnow.getMonth()) ? '' : ', '+month;
      }
      if (!nohours) {
        dateString += " "+hours;
        if (parseInt(notnow.getMinutes()) != 0)
          dateString += ":"+notnow.getMinutes();
        dateString += " "+ampm;
      }

      return dateString;
    },
    nextDate(){
      this.date += 1;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/booking/invitation.vue